export const viewTypes = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
}
